import { Random } from '../../Utility/Random';

export enum GrowthStage {
    LOCKED = 'locked',
    GROWING = 'growing',
    READY = 'ready',
    HARVESTED = 'harvested',
}

export interface IFieldData {
    id: string;
    requiredLevel: number[];
    growthStages: {
        [key in GrowthStage]: Random.IWeightedItem<string>[];
    };
    cropUnlockedTextures: string[];
    nodeTexture: string;
    cropSettings: ICropSettings;
}

export interface IHarvestSettings {
    originPoint: { x: number; y: number };
    radius: number;
    count: number;
    icons: Random.IWeightedItem<string>[];
}

export interface ICropSettings {
    harvestSettings: IHarvestSettings;
    base: string;
}

export type tCropTextureMap = {
    [key in GrowthStage]: Random.IWeightedItem<string>[];
};
